import sha256 from 'sha256';
import axios from 'axios';
import { BUHTABLE_RESET } from './buhtable';
import Axios from 'axios';
import qs from 'qs';

export const USER_AUTHENTICATE = 'USER_AUTHENTICATE';
export const USER_AUTHENTICATE_PENDING = 'USER_AUTHENTICATE_PENDING';
export const USER_AUTHENTICATE_REJECTED = 'USER_AUTHENTICATE_REJECTED';
export const USER_AUTHENTICATE_FULFILLED = 'USER_AUTHENTICATE_FULFILLED';

export const USER_AUTHENTICATE_CACHE = 'USER_AUTHENTICATE_CACHE';
export const USER_AUTHENTICATE_RESET = 'USER_AUTHENTICATE_RESET';

export const userAuthenticate = (username, password) => {
    return (dispatch) => {
        dispatch({ type: USER_AUTHENTICATE_PENDING });
        return axios('https://gstables.grandsova.com/api/authenticate', {
            method: 'POST',
            data: qs.stringify({
                username: username,
                password: sha256(password)
            })
        })
        .then(response => {
            dispatch({
                type: USER_AUTHENTICATE_FULFILLED,
                payload: response.data
            })
        })
        .catch(error => {
            dispatch({
                type: USER_AUTHENTICATE_REJECTED,
                error: error
            })            
        })
    }
};

export const userAuthenticateReset = () => {
    return {
        type: USER_AUTHENTICATE_RESET
    }
};

export const userAuthenticateCache = () => {
    return (dispatch) => {
        const user = sessionStorage.getItem('@user');
        if(user && user.length > 0) {
            dispatch({
                type: USER_AUTHENTICATE_CACHE,
                user: JSON.parse(user)
            })
        }
    }
};


// WEBPACK FOOTER //
// ./src/_actions/user.js